import * as Yup from 'yup';

export const formSchema = [
  {
    name: 'phoneNumber',
    validate: Yup.string()
      .required('Vui lòng nhập số điện thoại người nhận')
      .matches(/^[0-9]{10,11}$/, 'Số điện thoại phải gồm 10 hoặc 11 chữ số'),
  },
  {
    name: 'amount',
    validate: Yup.number()
      .typeError('Số điểm không hợp lệ')
      .moreThan(0, 'Số điểm phải lớn hơn 0')
      .required('Vui lòng nhập số điểm cần chuyển'),
  },
];

export const formSchemaPinCode = [
  {
    name: 'pinCode',
    validate: Yup.number()
      // .typeError('Mật khẩu phải là số')
      .test(
        'len',
        'Mật khẩu phải có ít nhất 6 kí tự',
        (val) => (val?.toString().length ?? 0) >= 6,
      ),
  },
];
